<div class="card">
	<div class="card-header">
		<h1>Bancarización</h1>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col form-group">
				<label for="company" class="form-label">Empresa:</label>
				<div class="input-group">
					<app-input-autocomplete (changeStatus)="selectCompany($event.filterElement)"
						(inputMethod)="searchCompany()" [allBorderRadius]="true" [filterElements]="companies"
						[placeholder]="'Busca una empresa'" [custom]="true" [inputs]="inputs">
						<ng-template #itemsTemplate let-filter>
							<!-- This is the content that will be projected -->
							<div items>
								<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
									{{filter.companyName?filter.companyName:filter.name}}</h5>
								<span class="text-muted" style="color: white !important;">{{filter.alphanumericId}} -
									NIT: <b>{{filter.companyNIT?filter.companyNIT:filter.nit}}</b></span>
							</div>
						</ng-template>
					</app-input-autocomplete>
				</div>
			</div>
			<div class="col form-group" *ngIf="selected">
				<label for="bank" class="form-label">Banco</label>
				<select name="bank" [disabled]="banks==null || banks.length == 0" (change)="removeBank()" [(ngModel)]="accountSelected"
					id="bank" class="form-select">
					<ng-container *ngIf="banks==null || banks.length == 0">
						<option value="undefined">No tiene cuentas</option>
					</ng-container>
					<ng-container *ngIf="banks && banks.length > 0">
						<option value="undefined">Selecciona una cuenta</option>
					</ng-container>
					<option *ngFor="let bank of banks" value="{{bank.id}}">{{bank.accountNumber}} - {{bank.alias}}
					</option>
				</select>
			</div>
		</div>
		<div *ngIf="selected">
			<hr>
			<h5>Archivo a cargar</h5>
			<div class="input-group">
				<input type="file" (change)="onFileSelected($event)" name="file" id="file" class="form-control">
			</div>
		</div>
		<div *ngIf="registers.length > 0">
			<hr>
			<h5>Registros del documento</h5>
			<div class="table-responsive">
				<table class="table">
					<thead>
						<tr>
							<th>Fecha</th>
							<th>Referencia</th>
							<th>Debito(-)</th>
							<th>Crédito(+)</th>
							<th>Saldo</th>
							<th>Detalle</th>
							<th>Operación</th>
							<th>Cliente/Destino</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let register of registers">
							<td>{{register.date}}</td>
							<td>{{register.reference}}</td>
							<td>{{register.debit | currency: 'Q'}}</td>
							<td>{{register.credit | currency: 'Q'}}</td>
							<td>{{register.balance | currency: 'Q'}}</td>
							<td>{{register.description}}</td>
							<td>
								<select name="type" [(ngModel)]="register.operation" id="type" (change)="reset(register)" class="form-select">
									<option value="1" selected="selected">Transferencia entre Bancos
									</option>
									<option value="2">Transferencia De Caja a Bancos</option>
									<option value="3">Cobro Cuenta por Cobrar</option>
									<option value="4">Pago Cuenta por Pagar</option>
									<option value="5">Anticipo Entrante</option>
									<option value="6">Anticipo Saliente</option>
									<option value="7">Pago Impuestos</option>
									<option value="8">Préstamos por Cobrar</option>
									<option value="9">Préstamos por Pagar</option>
									<option value="10">Pago de Lote</option>
									<option value="11">Cobro tarjeta de Crédito</option>
								</select>
							</td>
							<td>
								<ng-container *ngIf="register.operation == 1">
									<select name="client" id="client" class="form-select" [(ngModel)]="register.client">
										<option *ngFor="let bank of banksForClients" value="{{bank.id}}">{{bank.accountNumber}} -
											{{bank.alias}}</option>
									</select>
								</ng-container>
								<ng-container *ngIf="register.operation == 2">
									<select name="client" id="client" class="form-select" [(ngModel)]="register.client">
										<option *ngFor="let cash of cashiers" value="{{cash.id}}">{{cash.name}}</option>
									</select>
								</ng-container>
								<ng-container *ngIf="register.operation == 7">
									<select name="client" id="client" class="form-select" [(ngModel)]="register.client">
										<option value="20">IVA por pagar</option>
										<option value="21">Débito Fiscal</option>
										<option value="22">ISR Trimestral</option>
										<option value="23">ISR Mensual</option>
										<option value="24">Retenciones ISR</option>
										<option value="25">Impuesto Solidaridad</option>
										<option value="26">IGSS</option>
									</select>
								</ng-container>
								<ng-container *ngIf="(register.operation > 2 && register.operation < 7) 
									|| (register.operation > 7 && register.operation < 10)">
									<div class="input-group">
										<app-input-autocomplete (inputMethod)="writeClient(register)"
											[allBorderRadius]="true"
											[filterElements]="register['input']['filterElements']"
											[placeholder]="'Buscar cliente/destino'" [custom]="true"
											[inputs]="register['input']" (changeStatus)="selectClient($event.filterElement, register)">
											<ng-template #itemsTemplate let-filter>
												<!-- This is the content that will be projected -->
												<div items>
													<span class="text-info"
														style="line-height: normal; margin-bottom: 0;">
														{{filter.name}}</span>
													<hr style="margin: 0 !important;">
												</div>
											</ng-template>
										</app-input-autocomplete>
									</div>
								</ng-container>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<app-loading-button [object]="upload" [disabled]="!selected && !accountSelected" (clicked)="uploadRegisters()"></app-loading-button>
		</div>
	</div>
</div>